import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AllPermissionsDataType, TableFilterApiBody } from '../types'
const initialState: AllPermissionsDataType = {
  permissions: [],
}

const allPermissionsSlice = createSlice({
  name: 'allPermissions',
  initialState: initialState,
  reducers: {
    getAllPermissions: (_state, _action: PayloadAction<TableFilterApiBody>) => {
      return
    },
    updateAllPermissionState: (
      state,
      action: PayloadAction<AllPermissionsDataType>
    ) => {
      state.permissions = action.payload.permissions
    },
  },
})

export const { getAllPermissions, updateAllPermissionState } =
  allPermissionsSlice.actions
export default allPermissionsSlice.reducer
